import { CalculateCareerLayerStatisticsUseCase } from '@/application/careerLayer/calculateCareerLayerStatisticsUseCase';
import { ConsolidateCareerLayerByYearsUseCase } from '@/application/careerLayer/consolidateCareerLayerByYearsUseCase';
import { ExtractRiskIndicatorsOfCareerLayerUseCase } from '@/application/careerLayer/extractRiskIndicatorsOfCareerLayerUseCase';
import { FilterCareerLayerByJornadaUseCase } from '@/application/careerLayer/filterCareerLayerByJornadaUseCase';
import { FilterCareerLayerByYearUseCase } from '@/application/careerLayer/filterCareerLayerByYearUseCase';
import { GetCareerLayerUseCase } from '@/application/careerLayer/getCareerLayerUseCase';
import { ProcessCareerLayerDataUseCase } from '@/application/careerLayer/processCareerLayerDataUseCase';
import { TransformCareerLayerModulesToUIUseCase } from '@/application/careerLayer/transformCareerLayerModulesToUIUseCase';
import { careerLayerApiRepository } from '@/infra';

let _getCareerLayerUseCase: GetCareerLayerUseCase | null = null;
let _processCareerLayerDataUseCase: ProcessCareerLayerDataUseCase | null = null;
let _extractRiskIndicatorsOfCareerLayerUseCase: ExtractRiskIndicatorsOfCareerLayerUseCase | null =
  null;
let _calculateCareerLayerStatisticsUseCase: CalculateCareerLayerStatisticsUseCase | null =
  null;
let _transformCareerLayerModulesToUIUseCase: TransformCareerLayerModulesToUIUseCase | null =
  null;

export const getCareerLayerUseCase = (): GetCareerLayerUseCase => {
  if (!_getCareerLayerUseCase) {
    _getCareerLayerUseCase = new GetCareerLayerUseCase(
      careerLayerApiRepository,
    );
  }
  return _getCareerLayerUseCase;
};

export const processCareerLayerDataUseCase =
  (): ProcessCareerLayerDataUseCase => {
    if (!_processCareerLayerDataUseCase) {
      _processCareerLayerDataUseCase = new ProcessCareerLayerDataUseCase(
        new FilterCareerLayerByYearUseCase(),
        new ConsolidateCareerLayerByYearsUseCase(),
        new FilterCareerLayerByJornadaUseCase(),
      );
    }

    return _processCareerLayerDataUseCase;
  };

export const extractRiskIndicatorsOfCareerLayerUseCase =
  (): ExtractRiskIndicatorsOfCareerLayerUseCase => {
    if (!_extractRiskIndicatorsOfCareerLayerUseCase) {
      _extractRiskIndicatorsOfCareerLayerUseCase =
        new ExtractRiskIndicatorsOfCareerLayerUseCase();
    }

    return _extractRiskIndicatorsOfCareerLayerUseCase;
  };

export const calculateCareerLayerStatisticsUseCase =
  (): CalculateCareerLayerStatisticsUseCase => {
    if (!_calculateCareerLayerStatisticsUseCase) {
      _calculateCareerLayerStatisticsUseCase =
        new CalculateCareerLayerStatisticsUseCase();
    }
    return _calculateCareerLayerStatisticsUseCase;
  };

export const transformCareerLayerModulesToUIUseCase =
  (): TransformCareerLayerModulesToUIUseCase => {
    if (!_transformCareerLayerModulesToUIUseCase) {
      _transformCareerLayerModulesToUIUseCase =
        new TransformCareerLayerModulesToUIUseCase();
    }
    return _transformCareerLayerModulesToUIUseCase;
  };

export const resetCareerLayerContainer = (): void => {
  _getCareerLayerUseCase = null;
  _processCareerLayerDataUseCase = null;
  _extractRiskIndicatorsOfCareerLayerUseCase = null;
  _calculateCareerLayerStatisticsUseCase = null;
  _transformCareerLayerModulesToUIUseCase = null;
};
